import React, { FC, useMemo } from 'react';
import {
  NestedTableSpinnerCont,
  ReportsNestedTableBodyCont,
} from './ReportsNestedTableBody.styles';
import { IItemReportResponse } from '../../../../services/reports';
import ReportsNestedTableTile from '../ReportsNestedTableTile/ReportsNestedTableTile';
import Spinner from '../../../Spinner/Spinner';

interface IReportsNestedTableBody {
  items: IItemReportResponse[];
  surveyType: string;
  loading?: boolean;
}

const ReportsNestedTableBody: FC<IReportsNestedTableBody> = ({ items, surveyType, loading }) => {
  const renderItems = useMemo(() => {
    return items.map((item: IItemReportResponse) => (
      <ReportsNestedTableTile item={item} key={item.id} surveyType={surveyType} depth={0} />
    ));
  }, [items]);

  return (
    <ReportsNestedTableBodyCont id="ReportsNestedTableBodyCont">
      {loading ? (
        <NestedTableSpinnerCont id="NestedTableSpinnerCont">
          <Spinner size="default" />
        </NestedTableSpinnerCont>
      ) : (
        renderItems
      )}
    </ReportsNestedTableBodyCont>
  );
};

export default ReportsNestedTableBody;
